/* eslint-disable react/display-name, @typescript-eslint/no-empty-function */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: caoran
 * @LastEditTime: 2026-05-21 16:50:06
 */
import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'
import { Badge, Drawer, Tooltip } from 'antd'
import classnames from 'classnames'
import { useAppDispatch, useAppSelector, useVip } from '../../../../app/hooks'
import {
  fetchNoticeList,
  setHasNewNotify,
  toViewAction
} from '../../../../actions/main'
import sensors, { sensorsRole } from '../../../../utils/sensors'
import global_border_notify from '../../../../images/header/global_border_notify.png'

// 通知项类型
interface NoticeItem {
  notifyTime: string
  noticeContent: string
  isExpire: boolean
  toView: string
  sensor_plan_id?: string
  sensor_plan_name?: string
}
// eslint-disable-next-line react/display-name

export default () => {
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState<NoticeItem[]>([])
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const groupID = useAppSelector((state) => state.group.groupId)
  const myRole = useAppSelector((state) => state.group.myRole)
  const vipInfo = useVip()
  const isSpaceOpen = useAppSelector(
    (state) => (state as any).mySpace?.personalSpace?.isSpaceOpen ?? false
  )

  const hasNewNotify = useAppSelector((state) => state.main.hasNewNotify)

  const handleClick = () => {
    dispatch(setHasNewNotify(false))
    setVisible(true)

    sensors.track('web_workgroup_nav_menu_cli', {
      path: 'notification',
      groupID,
      isGroupVIP: vipInfo.isVip,
      bool1: isSpaceOpen
    })
  }

  useEffect(() => {
    let ignore = false

    if (visible) {
      dispatch(fetchNoticeList({ userID })).then((res) => {
        if (!ignore) {
          setData(res.notice_List)
        }
      })
    }

    return () => {
      ignore = true
    }
  }, [visible, userID, dispatch])

  return (
    <>
      <div className={styles.notifyBtn} onClick={handleClick}>
        <Tooltip title="通知" placement="bottom">
          <Badge dot={hasNewNotify} offset={[-2, 2]}>
            {/* <Icon type="bulb" style={{ fontSize: 12 }} /> */}
            <img
              src={global_border_notify}
              style={{ width: 24, height: 24 }}
              alt="通知"
            />
          </Badge>
        </Tooltip>
      </div>

      <Drawer
        title="通知"
        open={visible}
        onClose={() => {
          setVisible(false)

          sensors.track('web_click_page_notification_detail', {
            clickItem: 'close',
            groupID,
            role: sensorsRole(myRole)
          })
        }}
        size={350}
      >
        <>
          <div className={styles.listContainer}>
            {data.map((item, index) => (
              <div
                key={index}
                className={classnames(styles.notifyCard, {
                  [styles.expired]: item.isExpire
                })}
                onClick={() => {
                  const toview = JSON.parse(item.toView)
                  dispatch(toViewAction(toview))

                  sensors.track('web_click_page_notification_detail', {
                    clickItem: 'oneNotification',
                    functionID: item.sensor_plan_id,
                    functionName: item.sensor_plan_name,
                    groupID,
                    role: sensorsRole(myRole)
                  })
                }}
              >
                <div className={styles.expiredTime}>
                  {item.notifyTime}
                  {item.isExpire && (
                    <span className={styles.expiredTag}>已过期</span>
                  )}
                </div>
                <div className={styles.content}>{item.noticeContent}</div>
              </div>
            ))}
          </div>

          <div className={styles.tip}>当前只展示6个月内的通知</div>
        </>
      </Drawer>
    </>
  )
}
